import axios from "axios";
import { Urls } from "../slices/urls";
import { BASE_URL } from "../slices/urls";
import {ServiceUrls} from '../serviceUrl'

export const postEngineeringIdpRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_ENGINEERING_API,
    data: data,
  });
};

//POST_IDP_IMS_PUSH_API
export const postImsPushRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_IMS_PUSH_API,
    data: data,
  });
};

export const getEngineeringIdpStatusRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_API,
    params: params,
  });
};

export const getEngineeringIdpNonPanCollegesRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_NONPAN_COLLEGES_API,
    params: params,
  });
};